// Generated by purs version 0.15.15
import * as Common from "../Common/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as DOM_HTML_Indexed_InputType from "../DOM.HTML.Indexed.InputType/index.js";
import * as DOM_HTML_Indexed_StepValue from "../DOM.HTML.Indexed.StepValue/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Random from "../Effect.Random/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Halogen_Aff_Util from "../Halogen.Aff.Util/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen_Subscription from "../Halogen.Subscription/index.js";
import * as Halogen_VDom_Driver from "../Halogen.VDom.Driver/index.js";
import * as ProtoVoices_JSONTransport from "../ProtoVoices.JSONTransport/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
import * as ProtoVoices_RenderSVG from "../ProtoVoices.RenderSVG/index.js";
import * as Pruning from "../Pruning/index.js";
import * as Render from "../Render/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM);
var get = /* #__PURE__ */ Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var min = /* #__PURE__ */ Data_Ord.min(Data_Ord.ordInt);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Pitches_Class.showPitch(Data_Pitches_Spelled.notationPitchSInterval));
var show2 = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var type_ = /* #__PURE__ */ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType);
var value = /* #__PURE__ */ Halogen_HTML_Properties.value(Halogen_HTML_Core.isPropString);
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var readForeignVariant = /* #__PURE__ */ Simple_JSON.readForeignVariant();
var readMaybe = /* #__PURE__ */ Simple_JSON.readMaybe(Simple_JSON.readString);
var readFieldsCons = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "left";
    }
});
var readFieldsCons1 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
});
var readRecord1 = /* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons1(Simple_JSON.readString)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "pitch";
    }
})(/* #__PURE__ */ Data_Pitches_Class.readForeignPitch(Data_Pitches_Spelled.readForeignPitchSInterval))(Simple_JSON.readFieldsNil)()())()());
var readForeignStartStop = /* #__PURE__ */ ProtoVoices_Model.readForeignStartStop(readRecord1);
var readFieldsCons2 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "right";
    }
});
var readRecord2 = /* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(readForeignStartStop)(/* #__PURE__ */ readFieldsCons2(readForeignStartStop)(Simple_JSON.readFieldsNil)()())()());
var readArray = /* #__PURE__ */ Simple_JSON.readArray(readRecord2);
var readRecord3 = /* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "prevTime";
    }
})(readMaybe)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "ties";
    }
})(readArray)(Simple_JSON.readFieldsNil)()())()());
var readFieldsCons3 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "children";
    }
});
var readFieldsCons4 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "child";
    }
});
var readArray1 = /* #__PURE__ */ Simple_JSON.readArray(readRecord1);
var readRecord4 = /* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(readArray1)(/* #__PURE__ */ readFieldsCons2(readArray1)(Simple_JSON.readFieldsNil)()())()());
var readFieldsCons5 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "parent";
    }
});
var readFieldsCons6 = /* #__PURE__ */ readFieldsCons5(readRecord1)(Simple_JSON.readFieldsNil)()();
var readFieldsCons7 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "ids";
    }
});
var readFieldsCons8 = /* #__PURE__ */ readFieldsCons(ProtoVoices_Model.readForeignTransId);
var readFieldsCons9 = /* #__PURE__ */ readFieldsCons2(ProtoVoices_Model.readForeignTransId);
var readFieldsCons10 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "rslice";
    }
});
var readFieldsCons11 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "passing";
    }
});
var readFieldsCons12 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "regular";
    }
});
var readRecord5 = /* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons11(readArray)(/* #__PURE__ */ readFieldsCons12(readArray)(Simple_JSON.readFieldsNil)()())()());
var readFieldsCons13 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "unexplained";
    }
});
var readFieldsCons14 = /* #__PURE__ */ readFieldsCons3(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons4(readRecord1)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "orn";
    }
})(readMaybe)(Simple_JSON.readFieldsNil)()())()())));
var readArray2 = /* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons14(readFieldsCons6)()()));
var readArray3 = /* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons14(/* #__PURE__ */ readFieldsCons5(readRecord2)(Simple_JSON.readFieldsNil)()())()()));
var readRecord6 = /* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "fromLeft";
    }
})(readArray2)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "fromRight";
    }
})(readArray2)(/* #__PURE__ */ readFieldsCons7(/* #__PURE__ */ Simple_JSON.readMaybe(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons8(/* #__PURE__ */ readFieldsCons9(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "slice";
    }
})(ProtoVoices_Model.readForeignSliceId)(Simple_JSON.readFieldsNil)()())()())()())))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "keepLeft";
    }
})(readArray)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "keepRight";
    }
})(readArray)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "passLeft";
    }
})(readArray)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "passRight";
    }
})(readArray)(/* #__PURE__ */ readFieldsCons11(readArray3)(/* #__PURE__ */ readFieldsCons12(readArray3)(/* #__PURE__ */ readFieldsCons13(/* #__PURE__ */ Simple_JSON.readMaybe(readArray1))(Simple_JSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()());
var readRecord7 = /* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons1(/* #__PURE__ */ Simple_JSON.readMaybe(ProtoVoices_Model.readForeignSliceId))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "notes";
    }
})(/* #__PURE__ */ ProtoVoices_Model.readForeignStartStop(readArray1))(Simple_JSON.readFieldsNil)()())()());
var readRecord8 = /* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "classes";
    }
})(Simple_JSON.readString)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "label";
    }
})(Simple_JSON.readString)(Simple_JSON.readFieldsNil)()())()());
var readObject = /* #__PURE__ */ Simple_JSON.readObject(readRecord8);
var readJSON = /* #__PURE__ */ Simple_JSON.readJSON(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "derivation";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readForeignVariant(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "freezeLeft";
    }
})(readRecord3)()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "freezeOnly";
    }
})(readRecord3)()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "hori";
    }
})(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons3(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons4(/* #__PURE__ */ readForeignVariant(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "bothChildren";
    }
})(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(readRecord1)(/* #__PURE__ */ readFieldsCons2(readRecord1)(Simple_JSON.readFieldsNil)()())()()))()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "leftChild";
    }
})(readRecord1)()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "rightChild";
    }
})(readRecord1)()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "tooManyChildren";
    }
})(readRecord4)()(Simple_JSON.readVariantNil))))))(readFieldsCons6)()())))(/* #__PURE__ */ readFieldsCons7(/* #__PURE__ */ Simple_JSON.readMaybe(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons8(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "lslice";
    }
})(ProtoVoices_Model.readForeignSliceId)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "mid";
    }
})(ProtoVoices_Model.readForeignTransId)(/* #__PURE__ */ readFieldsCons9(/* #__PURE__ */ readFieldsCons10(ProtoVoices_Model.readForeignSliceId)(Simple_JSON.readFieldsNil)()())()())()())()())()())))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "midEdges";
    }
})(readRecord5)(/* #__PURE__ */ readFieldsCons13(/* #__PURE__ */ Simple_JSON.readMaybe(readRecord4))(Simple_JSON.readFieldsNil)()())()())()())()()))()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "splitLeft";
    }
})(readRecord6)()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "splitOnly";
    }
})(readRecord6)()(/* #__PURE__ */ Simple_JSON.readVariantCons({
    reflectSymbol: function () {
        return "splitRight";
    }
})(readRecord6)()(Simple_JSON.readVariantNil)))))))))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "start";
    }
})(readRecord7)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "styles";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "css";
    }
})(Simple_JSON.readString)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "edgeStyles";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "edge";
    }
})(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(Simple_JSON.readString)(/* #__PURE__ */ readFieldsCons2(Simple_JSON.readString)(Simple_JSON.readFieldsNil)()())()()))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "style";
    }
})(readRecord8)(Simple_JSON.readFieldsNil)()())()())))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "noteStyles";
    }
})(readObject)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "sliceStyles";
    }
})(readObject)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "staffType";
    }
})(Simple_JSON.readString)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "transStyles";
    }
})(readObject)(Simple_JSON.readFieldsNil)()())()())()())()())()())()())))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "topSegments";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons10(readRecord7)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "trans";
    }
})(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "edges";
    }
})(readRecord5)(/* #__PURE__ */ readFieldsCons1(/* #__PURE__ */ Simple_JSON.readMaybe(ProtoVoices_Model.readForeignTransId))(Simple_JSON.readFieldsNil)()())()()))(Simple_JSON.readFieldsNil)()())()())))(Simple_JSON.readFieldsNil)()())()())()())()()));
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Halogen_Query_HalogenM.bindHalogenM);
var $$void = /* #__PURE__ */ Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var discard2 = /* #__PURE__ */ discard(Effect_Aff.bindAff);
var bind3 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect_Aff.applicativeAff)(Data_Foldable.foldableMaybe);
var updateStepModel = function (step) {
    return function (max1) {
        return function (model) {
            return function (cache) {
                return bind(Data_Either.hush(Common.cacheGetPruned(model)(step)(cache)))(function (modelPruned) {
                    var surface = Common.cacheGetSurface(modelPruned)(step)(cache);
                    var graph = Common.cacheGetGraph(modelPruned)(step)(cache);
                    return pure({
                        model: model,
                        step: step,
                        max: max1,
                        modelPruned: modelPruned,
                        graph: graph,
                        surface: surface
                    });
                });
            };
        };
    };
};
var redrawScore = function (dictMonadEffect) {
    var liftEffect = Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect));
    return bind1(get)(function (st) {
        var update = bind(st.model)(function (v) {
            return bind(st.scoreElt)(function (scoreElt) {
                var totalWidth = Render.scalex(st.settings)(Data_Int.toNumber(Data_Array.length(v.model.piece))) + Render.sliceWidth / 2.0;
                var toX = function (x) {
                    return Render.scalex(st.settings)(x);
                };
                var select = function (sel) {
                    return Halogen_Subscription.notify(st.eventListener)(new Common.Select(sel));
                };
                return pure(liftEffect(ProtoVoices_RenderSVG.insertScore(scoreElt)(ProtoVoices_RenderSVG.renderGraph(v.graph)(v.model.piece)(v.surface)(v.model.styles)(st.selected)(new Data_Maybe.Just(select))(toX)(totalWidth)(Render.scoreScale)(st.settings.showSurface))));
            });
        });
        return Data_Maybe.fromMaybe(pure1(Data_Unit.unit))(update);
    });
};
var viewerComponent = function (dictMonadEffect) {
    return function (dictMonadAff) {
        var MonadEffect0 = dictMonadAff.MonadEffect0();
        var log = Effect_Class_Console.log(Halogen_Query_HalogenM.monadEffectHalogenM(MonadEffect0));
        var redrawScore1 = redrawScore(MonadEffect0);
        return function (prefix) {
            return function (v) {
                var setStep = function (f) {
                    return function (st) {
                        return Data_Maybe.fromMaybe(st)(bind(st.model)(function (v1) {
                            var step$prime = max(0)(min(v1.max)(f(v1.step)));
                            return bind(updateStepModel(step$prime)(v1.max)(v1.model)(st.cache))(function (model$prime) {
                                return pure((function () {
                                    var $512 = {};
                                    for (var $513 in st) {
                                        if ({}.hasOwnProperty.call(st, $513)) {
                                            $512[$513] = st[$513];
                                        };
                                    };
                                    $512.model = new Data_Maybe.Just(model$prime);
                                    return $512;
                                })());
                            });
                        }));
                    };
                };
                var render = function (st) {
                    if (st.model instanceof Data_Maybe.Nothing) {
                        return Halogen_HTML_Elements.div([ Common.class_("pv-content") ])([ Halogen_HTML_Core.text("No analysis loaded.") ]);
                    };
                    if (st.model instanceof Data_Maybe.Just) {
                        return Halogen_HTML_Elements.div([ Common.class_("pv-widget") ])([ Halogen_HTML_Elements.header([ Common.class_("pv-content pv-controls") ])([ Halogen_HTML_Elements.div([ Common.class_("pv-toolbar") ])([ Halogen_HTML_Elements.button([ Common.class_("pv-button pure-button"), Halogen_HTML_Events.onClick(function (v1) {
                            return Common.ToFirst.value;
                        }), Halogen_HTML_Properties.disabled(st.model.value0.step <= 0), Halogen_HTML_Properties.title("Move to first step") ])([ Halogen_HTML_Core.text("<< First") ]), Halogen_HTML_Elements.button([ Common.class_("pv-button pure-button"), Halogen_HTML_Events.onClick(function (v1) {
                            return Common.Backward.value;
                        }), Halogen_HTML_Properties.disabled(st.model.value0.step <= 0), Halogen_HTML_Properties.title("Move one step back") ])([ Halogen_HTML_Core.text("< Previous") ]), Halogen_HTML_Elements.button([ Common.class_("pv-button pure-button"), Halogen_HTML_Events.onClick(function (v1) {
                            return Common.Forward.value;
                        }), Halogen_HTML_Properties.disabled(st.model.value0.step >= st.model.value0.max), Halogen_HTML_Properties.title("Move one step forward") ])([ Halogen_HTML_Core.text("Next >") ]), Halogen_HTML_Elements.button([ Common.class_("pv-button pure-button"), Halogen_HTML_Events.onClick(function (v1) {
                            return Common.ToLast.value;
                        }), Halogen_HTML_Properties.disabled(st.model.value0.step >= st.model.value0.max), Halogen_HTML_Properties.title("Move to last step") ])([ Halogen_HTML_Core.text("Last >>") ]), Halogen_HTML_Elements.span([ Common.class_("pv-step") ])([ Halogen_HTML_Core.text(" Step " + (show(st.model.value0.step) + (" of " + (show(st.model.value0.max) + ".")))) ]), Halogen_HTML_Elements.span([ Common.class_("pv-step") ])([ (function () {
                            if (st.selected instanceof Data_Maybe.Just) {
                                return Halogen_HTML_Core.text("Note selected: " + (show1(st.selected.value0.note.pitch) + (", " + (Common.showExplanation(st.selected.value0.expl) + "."))));
                            };
                            if (st.selected instanceof Data_Maybe.Nothing) {
                                return Halogen_HTML_Core.text("No note selected.");
                            };
                            throw new Error("Failed pattern match at Main (line 156, column 23 - line 158, column 63): " + [ st.selected.constructor.name ]);
                        })() ]), Halogen_HTML_Elements.div([ Common.class_("pv-spacer") ])([  ]), Halogen_HTML_Elements.button([ Common.class_("pv-button pure-button" + (function () {
                            if (st.settings.showSettings) {
                                return " pv-button-pressed pure-button-active";
                            };
                            return "";
                        })()), Halogen_HTML_Events.onClick(function (v1) {
                            return Common.ToggleSettings.value;
                        }), Halogen_HTML_Properties.title("Show or hide settings") ])([ Halogen_HTML_Core.text("Settings") ]) ]), (function () {
                            if (st.settings.showSettings) {
                                return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.div([ Common.class_("pv-control-box") ])([ Halogen_HTML_Elements.label([ Common.class_("pv-control-label"), Halogen_HTML_Properties["for"]("xscale") ])([ Halogen_HTML_Core.text("horizontal zoom: " + show2(st.settings.xscale)) ]), Halogen_HTML_Elements.input([ Common.class_("pv-control-range"), type_(DOM_HTML_Indexed_InputType.InputRange.value), Halogen_HTML_Properties.min(-5.0), Halogen_HTML_Properties.max(0.0), Halogen_HTML_Properties.step(new DOM_HTML_Indexed_StepValue.Step(1.0e-2)), value(show2(st.settings.xscale)), Halogen_HTML_Events.onValueChange(Common.SetXScale.create), Halogen_HTML_Properties.name("xscale") ]) ]), Halogen_HTML_Elements.div([ Common.class_("pv-control-box") ])([ Halogen_HTML_Elements.label([ Common.class_("pv-control-label"), Halogen_HTML_Properties["for"]("yscale") ])([ Halogen_HTML_Core.text("vertical zoom: " + show2(st.settings.yscale)) ]), Halogen_HTML_Elements.input([ Common.class_("pv-control-range"), type_(DOM_HTML_Indexed_InputType.InputRange.value), Halogen_HTML_Properties.min(-2.0), Halogen_HTML_Properties.max(2.0), Halogen_HTML_Properties.step(new DOM_HTML_Indexed_StepValue.Step(1.0e-2)), value(show2(st.settings.yscale)), Halogen_HTML_Events.onValueChange(Common.SetYScale.create), Halogen_HTML_Properties.name("yscale") ]) ]), Halogen_HTML_Elements.div([ Common.class_("pv-control-box") ])([ Halogen_HTML_Elements.input([ type_(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(st.settings.showInner), Halogen_HTML_Events.onChange(function (v1) {
                                    return Common.ToggleInner.value;
                                }), Halogen_HTML_Properties.id(prefix + "showInnerGraph") ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"](prefix + "showInnerGraph") ])([ Halogen_HTML_Core.text("show inner graph") ]) ]), Halogen_HTML_Elements.div([ Common.class_("pure-g") ])([ Halogen_HTML_Elements.div([ Common.class_("pure-u-1-2 pv-control-box") ])([ Halogen_HTML_Elements.input([ type_(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(st.settings.showScore), Halogen_HTML_Events.onChange(function (v1) {
                                    return Common.ToggleScore.value;
                                }), Halogen_HTML_Properties.id(prefix + "showScore") ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"](prefix + "showScore") ])([ Halogen_HTML_Core.text("show score") ]) ]), Halogen_HTML_Elements.div([ Common.class_("pure-u-1-2 pv-control-box") ])([ Halogen_HTML_Elements.input([ type_(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(st.settings.showSurface), Halogen_HTML_Properties.enabled(st.settings.showScore), Halogen_HTML_Events.onChange(function (v1) {
                                    return Common.ToggleSurface.value;
                                }), Halogen_HTML_Properties.id(prefix + "showSurface") ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"](prefix + "showSurface") ])([ Halogen_HTML_Core.text("show surface below graph") ]) ]) ]), Halogen_HTML_Elements.div([ Common.class_("pv-control-box") ])([ Halogen_HTML_Elements.input([ type_(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(st.settings.showOuter), Halogen_HTML_Events.onChange(function (v1) {
                                    return Common.ToggleOuter.value;
                                }), Halogen_HTML_Properties.id(prefix + "showOuterGraph") ]), Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"](prefix + "showOuterGraph") ])([ Halogen_HTML_Core.text("show outer graph") ]) ]) ]);
                            };
                            return Halogen_HTML_Core.text("");
                        })() ]), Halogen_HTML_Elements.div([ Common.class_("pv-wide") ])([ Halogen_HTML_Elements.div([ Common.class_("pv-graph") ])([ (function () {
                            if (st.settings.showInner) {
                                return Render.renderInner(st.settings)(st.selected)(st.model.value0.surface)(st.model.value0.graph);
                            };
                            return Halogen_HTML_Core.text("");
                        })(), (function () {
                            if (st.settings.showScore) {
                                return Render.renderScoreSVG(st.settings)(st.model.value0.graph)(Data_List.length(st.model.value0.model.reduction.segments) === 1)(st.model.value0.model.styles.staff);
                            };
                            return Halogen_HTML_Core.text("");
                        })(), (function () {
                            if (st.settings.showOuter) {
                                return Render.renderReduction(st.settings)(st.model.value0.graph)(st.selected);
                            };
                            return Halogen_HTML_Core.text("");
                        })() ]) ]) ]);
                    };
                    throw new Error("Failed pattern match at Main (line 118, column 15 - line 256, column 10): " + [ st.model.constructor.name ]);
                };
                var initialState = function (v1) {
                    var model = bind(Data_Either.hush(readJSON(v1.json)))(function (v2) {
                        return bind(Data_Either.hush(ProtoVoices_JSONTransport.modelFromJSON(v2)))(function (m) {
                            var max1 = Pruning.countSteps(m.reduction);
                            return pure({
                                model: m,
                                modelPruned: m,
                                step: max1,
                                max: max1
                            });
                        });
                    });
                    var cache = (function () {
                        if (model instanceof Data_Maybe.Just) {
                            return Common.fillCache(model.value0.model)(model.value0.step)(Common.emptyCache);
                        };
                        if (model instanceof Data_Maybe.Nothing) {
                            return Common.emptyCache;
                        };
                        throw new Error("Failed pattern match at Main (line 113, column 13 - line 115, column 28): " + [ model.constructor.name ]);
                    })();
                    return {
                        model: (function () {
                            if (model instanceof Data_Maybe.Just) {
                                return updateStepModel(model.value0.step)(model.value0.max)(model.value0.model)(cache);
                            };
                            if (model instanceof Data_Maybe.Nothing) {
                                return Data_Maybe.Nothing.value;
                            };
                            throw new Error("Failed pattern match at Main (line 96, column 9 - line 98, column 29): " + [ model.constructor.name ]);
                        })(),
                        cache: cache,
                        settings: v1.settings,
                        selected: Data_Maybe.Nothing.value,
                        scoreElt: Data_Maybe.Nothing.value,
                        eventListener: v.listener
                    };
                };
                var handleAction = function (v1) {
                    if (v1 instanceof Common.NoOp) {
                        return pure1(Data_Unit.unit);
                    };
                    if (v1 instanceof Common.Init) {
                        return discard1(log("initializing."))(function () {
                            return $$void(Halogen_Query_HalogenM.subscribe(v.emitter));
                        });
                    };
                    if (v1 instanceof Common.Select) {
                        return discard1(modify_(function (st) {
                            var $541 = {};
                            for (var $542 in st) {
                                if ({}.hasOwnProperty.call(st, $542)) {
                                    $541[$542] = st[$542];
                                };
                            };
                            $541.selected = v1.value0;
                            return $541;
                        }))(function () {
                            return redrawScore1;
                        });
                    };
                    if (v1 instanceof Common.Forward) {
                        return discard1(modify_(setStep(function (v2) {
                            return v2 + 1 | 0;
                        })))(function () {
                            return redrawScore1;
                        });
                    };
                    if (v1 instanceof Common.Backward) {
                        return discard1(modify_(setStep(function (v2) {
                            return v2 - 1 | 0;
                        })))(function () {
                            return redrawScore1;
                        });
                    };
                    if (v1 instanceof Common.ToFirst) {
                        return discard1(modify_(setStep(Data_Function["const"](0))))(function () {
                            return redrawScore1;
                        });
                    };
                    if (v1 instanceof Common.ToLast) {
                        return discard1(modify_(function (st) {
                            if (st.model instanceof Data_Maybe.Just) {
                                return setStep(Data_Function["const"](st.model.value0.max))(st);
                            };
                            if (st.model instanceof Data_Maybe.Nothing) {
                                return st;
                            };
                            throw new Error("Failed pattern match at Main (line 284, column 24 - line 286, column 22): " + [ st.model.constructor.name ]);
                        }))(function () {
                            return redrawScore1;
                        });
                    };
                    if (v1 instanceof Common.RegisterScoreElt) {
                        return discard1(modify_(function (st) {
                            var $548 = {};
                            for (var $549 in st) {
                                if ({}.hasOwnProperty.call(st, $549)) {
                                    $548[$549] = st[$549];
                                };
                            };
                            $548.scoreElt = new Data_Maybe.Just(v1.value0);
                            return $548;
                        }))(function () {
                            return redrawScore1;
                        });
                    };
                    if (v1 instanceof Common.ToggleSettings) {
                        return modify_(function (st) {
                            var $555 = {};
                            for (var $556 in st) {
                                if ({}.hasOwnProperty.call(st, $556)) {
                                    $555[$556] = st[$556];
                                };
                            };
                            $555.settings = (function () {
                                var $552 = {};
                                for (var $553 in st.settings) {
                                    if ({}.hasOwnProperty.call(st.settings, $553)) {
                                        $552[$553] = st["settings"][$553];
                                    };
                                };
                                $552.showSettings = !st.settings.showSettings;
                                return $552;
                            })();
                            return $555;
                        });
                    };
                    if (v1 instanceof Common.ToggleInner) {
                        return modify_(function (st) {
                            var $561 = {};
                            for (var $562 in st) {
                                if ({}.hasOwnProperty.call(st, $562)) {
                                    $561[$562] = st[$562];
                                };
                            };
                            $561.settings = (function () {
                                var $558 = {};
                                for (var $559 in st.settings) {
                                    if ({}.hasOwnProperty.call(st.settings, $559)) {
                                        $558[$559] = st["settings"][$559];
                                    };
                                };
                                $558.showInner = !st.settings.showInner;
                                return $558;
                            })();
                            return $561;
                        });
                    };
                    if (v1 instanceof Common.ToggleOuter) {
                        return modify_(function (st) {
                            var $567 = {};
                            for (var $568 in st) {
                                if ({}.hasOwnProperty.call(st, $568)) {
                                    $567[$568] = st[$568];
                                };
                            };
                            $567.settings = (function () {
                                var $564 = {};
                                for (var $565 in st.settings) {
                                    if ({}.hasOwnProperty.call(st.settings, $565)) {
                                        $564[$565] = st["settings"][$565];
                                    };
                                };
                                $564.showOuter = !st.settings.showOuter;
                                return $564;
                            })();
                            return $567;
                        });
                    };
                    if (v1 instanceof Common.ToggleScore) {
                        return modify_(function (st) {
                            var $573 = {};
                            for (var $574 in st) {
                                if ({}.hasOwnProperty.call(st, $574)) {
                                    $573[$574] = st[$574];
                                };
                            };
                            $573.settings = (function () {
                                var $570 = {};
                                for (var $571 in st.settings) {
                                    if ({}.hasOwnProperty.call(st.settings, $571)) {
                                        $570[$571] = st["settings"][$571];
                                    };
                                };
                                $570.showScore = !st.settings.showScore;
                                return $570;
                            })();
                            return $573;
                        });
                    };
                    if (v1 instanceof Common.ToggleSurface) {
                        return discard1(modify_(function (st) {
                            var $579 = {};
                            for (var $580 in st) {
                                if ({}.hasOwnProperty.call(st, $580)) {
                                    $579[$580] = st[$580];
                                };
                            };
                            $579.settings = (function () {
                                var $576 = {};
                                for (var $577 in st.settings) {
                                    if ({}.hasOwnProperty.call(st.settings, $577)) {
                                        $576[$577] = st["settings"][$577];
                                    };
                                };
                                $576.showSurface = !st.settings.showSurface;
                                return $576;
                            })();
                            return $579;
                        }))(function () {
                            return redrawScore1;
                        });
                    };
                    if (v1 instanceof Common.SetXScale) {
                        var v2 = Data_Number.fromString(v1.value0);
                        if (v2 instanceof Data_Maybe.Nothing) {
                            return pure1(Data_Unit.unit);
                        };
                        if (v2 instanceof Data_Maybe.Just) {
                            return discard1(modify_(function (st) {
                                var $586 = {};
                                for (var $587 in st) {
                                    if ({}.hasOwnProperty.call(st, $587)) {
                                        $586[$587] = st[$587];
                                    };
                                };
                                $586.settings = (function () {
                                    var $583 = {};
                                    for (var $584 in st.settings) {
                                        if ({}.hasOwnProperty.call(st.settings, $584)) {
                                            $583[$584] = st["settings"][$584];
                                        };
                                    };
                                    $583.xscale = v2.value0;
                                    return $583;
                                })();
                                return $586;
                            }))(function () {
                                return redrawScore1;
                            });
                        };
                        throw new Error("Failed pattern match at Main (line 298, column 20 - line 302, column 20): " + [ v2.constructor.name ]);
                    };
                    if (v1 instanceof Common.SetYScale) {
                        var v2 = Data_Number.fromString(v1.value0);
                        if (v2 instanceof Data_Maybe.Nothing) {
                            return pure1(Data_Unit.unit);
                        };
                        if (v2 instanceof Data_Maybe.Just) {
                            return discard1(modify_(function (st) {
                                var $595 = {};
                                for (var $596 in st) {
                                    if ({}.hasOwnProperty.call(st, $596)) {
                                        $595[$596] = st[$596];
                                    };
                                };
                                $595.settings = (function () {
                                    var $592 = {};
                                    for (var $593 in st.settings) {
                                        if ({}.hasOwnProperty.call(st.settings, $593)) {
                                            $592[$593] = st["settings"][$593];
                                        };
                                    };
                                    $592.yscale = v2.value0;
                                    return $592;
                                })();
                                return $595;
                            }))(function () {
                                return redrawScore1;
                            });
                        };
                        throw new Error("Failed pattern match at Main (line 303, column 20 - line 307, column 20): " + [ v2.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Main (line 266, column 18 - line 307, column 20): " + [ v1.constructor.name ]);
                };
                return Halogen_Component.mkComponent({
                    initialState: initialState,
                    render: render,
                    "eval": Halogen_Component.mkEval({
                        handleQuery: Halogen_Component.defaultEval.handleQuery,
                        receive: Halogen_Component.defaultEval.receive,
                        finalize: Halogen_Component.defaultEval.finalize,
                        handleAction: handleAction,
                        initialize: new Data_Maybe.Just(Common.Init.value)
                    })
                });
            };
        };
    };
};
var viewerComponent1 = /* #__PURE__ */ viewerComponent(Effect_Aff.monadEffectAff)(Effect_Aff_Class.monadAffAff);
var createViewer$prime = function (eltSelector) {
    return function (json) {
        return function (opts) {
            return function __do() {
                var pfx = map(show2)(Effect_Random.random)();
                var settings = Common.readOptions(opts);
                var subscription = Halogen_Subscription.create();
                return Halogen_Aff_Util.runHalogenAff(discard2(Halogen_Aff_Util.awaitLoad)(function () {
                    return bind3(Halogen_Aff_Util.selectElement(eltSelector))(function (elt) {
                        return for_(elt)(Halogen_VDom_Driver.runUI(viewerComponent1(pfx)(subscription))({
                            json: json,
                            settings: settings
                        }));
                    });
                }))();
            };
        };
    };
};
var createViewer = /* #__PURE__ */ Effect_Uncurried.mkEffectFn3(createViewer$prime);
export {
    createViewer,
    createViewer$prime,
    updateStepModel,
    viewerComponent,
    redrawScore
};
